import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { CardHeader as CardHeader$1, Stack } from '@chakra-ui/react';
var _excluded = ["stackDirection", "children"];
var CardHeader = function CardHeader(_ref) {
  var _ref$stackDirection = _ref.stackDirection,
    stackDirection = _ref$stackDirection === void 0 ? 'column' : _ref$stackDirection,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var computedProps = _objectSpread2({
    direction: stackDirection,
    spacing: 2
  }, stackDirection === 'row' && {
    justify: 'space-between',
    align: 'baseline'
  });

  /**
   * DOM
   */
  return /*#__PURE__*/React.createElement(CardHeader$1, _extends({}, rest, {
    "data-object-type": "core-card-header"
  }), /*#__PURE__*/React.createElement(Stack, computedProps, children));
};
CardHeader.displayName = "CardHeader";
export { CardHeader };